export class Settings {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}
